'use strict';

angular.module('licensure.services')
    .factory('LicenseScheduledTaskLogs', ['$http', '$q', function ($http, $q) {

        return {

            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licenseScheduledTaskLogs/', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licenseScheduledTaskLogs/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
    ;